import { render, staticRenderFns } from "./index.vue?vue&type=template&id=13ba52d7"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\chenwllCode\\cunxian\\web-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13ba52d7')) {
      api.createRecord('13ba52d7', component.options)
    } else {
      api.reload('13ba52d7', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=13ba52d7", function () {
      api.rerender('13ba52d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/appSetting/wxAccount/wxTemplate/index.vue"
export default component.exports